<template>
	<div class="detail_body">
		<div class="coll">
			<h2 class="title"><span>基础数据</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>物料号</th><td>{{sdata.materialCode}}</td>
						<th>物料描述</th><td>{{sdata.materialDesc}}</td>
					</tr>
					<tr>
						<th>物料组</th><td>{{sdata.materialGroupDesc}}</td>
						<th>物料类型</th><td>{{sdata.materialTypeName}}</td>
					</tr>
          <tr>
            <th>规格型号</th><td colspan="3">{{sdata.specifications}}</td>
          </tr>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>基本单位</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>基本计量单位</th><td>{{sdata.basicUnitDesc}}</td>
						<th>采购计量单位</th><td>{{sdata.purchUnitDesc}}</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>单位换算</span></h2>
			<div class="cons">
				<table class="tab_list">
					<thead>
						<th>数值</th>
						<th>基本计量单位</th>
						<th>数值</th>
						<th>换算计量单位</th>
					</thead>
					<tbody>
						<template v-if="sdata.multiUnit">
							<tr v-for="(item,index) in sdata.multiUnit">
								<td>{{item.numeratorUnitQuantity}}</td>
								<td>{{item.basicUnitDesc}}</td>
								<td>{{item.denominatorUnitQuantity}}</td>
								<td>{{item.denominatorUnitDesc}}</td>
							</tr>
						</template>
						<tr v-else>
							<td colspan="4" class="no_res">暂无数据</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>其他</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>批次管理</th><td>{{sdata.isBatchManager ? "需要":"不需要"}}</td>
						<th>是否质检</th><td>{{sdata.isInspection ? "是":"否"}}</td>
					</tr>
          <tr>
          	<th>创建日期</th><td>{{sdata.createDate}}</td>
          	<th>创建人</th><td>{{sdata.createUserName}}</td>
          </tr>
          <tr>
          	<th>上次更改的日期</th><td>{{sdata.lastModifyDate}}</td>
          	<th>更改人员名</th><td>{{sdata.modifyUserName}}</td>
          </tr>
					<tr>
						<th>当前状态</th>
						<td>{{sdata.maintainStatus === 'X' ? "已删除" : '正常'}}</td>
						<th>冻结状态</th>
						<td>{{sdata.maintainStatus === 'X' ? "已删除" : '正常'}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	props:{
		sdata:Object
	}
}
</script>

<style>
</style>
